export default "<p> WWE </p>";